import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CommandPaletteWrapper"] */ "/vercel/path0/components/command-palette-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompareButton"] */ "/vercel/path0/components/compare-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductComparison"] */ "/vercel/path0/components/product-comparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecaptchaProvider"] */ "/vercel/path0/components/recaptcha-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/shared-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/shared-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/components/toast-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/lib/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandPaletteProvider"] */ "/vercel/path0/lib/command-palette-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonProvider"] */ "/vercel/path0/lib/comparison-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyProvider"] */ "/vercel/path0/lib/currency-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuoteCartProvider"] */ "/vercel/path0/lib/quote-cart-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistProvider"] */ "/vercel/path0/lib/wishlist-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
